// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ButtonAction_action__\\+o0RB {\n  width: 120px;\n}\n", "",{"version":3,"sources":["webpack://./src/Components/Includes/ButtonAction.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".action {\n  width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action": "ButtonAction_action__+o0RB"
};
export default ___CSS_LOADER_EXPORT___;
